import { getNullLogger } from '@uniformdev/common';
export function getVisitActivities(type, visit, logger, loggerPrefix) {
  var _a;
  if (logger === void 0) {
    logger = getNullLogger();
  }
  var result = {};
  if (visit) {
    var activities = (_a = visit.data) === null || _a === void 0 ? void 0 : _a.activities;
    if (activities) {
      var filtered = activities.filter(function (a) {
        return a.type == type;
      });
      filtered.forEach(function (activity) {
        var _a, _b, _c;
        if (!((_a = activity.data) === null || _a === void 0 ? void 0 : _a.id)) {
          logger.debug("".concat(loggerPrefix, " - Activity was found on the visit but no id is set, so unable to include this activity in the activity results."), {
            type: type,
            activity: activity,
            visit: visit.id,
            visitor: visit.visitorId
          });
          return;
        }
        if (!activity.date) {
          logger.debug("".concat(loggerPrefix, " - Activity was found on the visit but no date is set, so unable to include this activity in the activity results."), {
            type: type,
            activity: activity,
            visit: visit.id,
            visitor: visit.visitorId
          });
          return;
        }
        var id = (_b = activity.data) === null || _b === void 0 ? void 0 : _b.id;
        var date = new Date(activity.date);
        if (id && date) {
          var dates = (_c = result[id]) !== null && _c !== void 0 ? _c : [];
          dates.push(date);
          result[id] = dates;
        }
      });
    }
  }
  return result;
}
export function getVisitorActivities(type, visitor, logger, loggerPrefix) {
  if (logger === void 0) {
    logger = getNullLogger();
  }
  var result = {};
  if (visitor === null || visitor === void 0 ? void 0 : visitor.visits) {
    visitor.visits.forEach(function (visit) {
      var activities = getVisitActivities(type, visit, logger, loggerPrefix);
      if (activities) {
        Object.keys(activities).forEach(function (id) {
          var dates = activities[id];
          if (dates) {
            if (!result[id]) {
              result[id] = dates;
            } else {
              var currentDates_1 = result[id];
              dates.forEach(function (date) {
                if (currentDates_1.findIndex(function (d) {
                  return d.getTime() === date.getTime();
                }) == -1) {
                  currentDates_1.push(date);
                }
              });
            }
          }
        });
      }
    });
  }
  return result;
}